

<template>
    <div class="index-content">
        <!-- header -->
        <div style="height: 48px;" class="b-bottom w-100">
            <div class="g-width" style="line-height: 48px; color: #333;">你好，欢迎来到四川省知识产权公共服务平台乐山分平台</div>
        </div>
        <div class="g-width flex" style="height: 124px;align-items: center;">
            <img src="@/assets/imgs/index/header-logo.png" style="margin-right: 22px;">
            <div>
                <!-- <div style="font-size: 30px;font-weight: 600;margin-bottom: 3px;">乐山市</div> -->
                <!-- <div style="font-size: 18px;">四川省知识产权公共服务平台乐山分平台</div> -->
				<div style="font-size: 30px;font-weight: 600;margin-bottom: 2px;">四川省知识产权公共服务平台乐山分平台</div>
            </div>
        </div>
        <RouterView />
        <div class="w-100 bgcolor2" style="height: 10px;"></div>
        <!-- link -->
        <!-- <div class="g-width linkfooter">
            <div>友情链接</div>
            <el-select style="width: 334px;" v-model="link1">
                <el-option label="国家知识产权部门" value="国家知识产权部门"></el-option>
            </el-select>
            <el-select style="width: 334px;" v-model="link2">
                <el-option label="省级知识产权部门" value="省级知识产权部门"></el-option>
            </el-select>
            <el-select style="width: 334px;" v-model="link3">
                <el-option label="市级知识产权部门" value="市级知识产权部门"></el-option>
            </el-select>
        </div> -->
        <!-- footer -->
        <div class="w-100 bgcolorFooter">
            <div class="g-width">
                <div>
                    <div class="f18b">相关链接</div>
                    <div style="cursor: pointer;" @click="jumpOuter('https://scjgj.leshan.gov.cn/')">乐山市市场监督管理局</div>
                    <div style="margin-top: 10px;cursor: pointer;" @click="jumpOuter('./#/homeoverview')">乐山知识产权数据分析平台</div>
                </div>
                <div>
                    <div class="f18b">主办单位</div>
                    <div>乐山职业技术学院</div>
                </div>
                <div>
                    <div class="f18b">技术支持电话</div>
                    <div class="f18b" style="font-size: 24px;">028-84168818</div>
                </div>
                <div>
                    <div class="f18b">主办方电话</div>
                    <div class="f18b" style="font-size: 24px;">0833-2274819</div>
                </div>
            </div>
            <div class="f-text">
                <span style="margin-right: 30px;">最佳使用效果1920x1080</span>
                <span style="margin-right: 30px;">推荐使用Google Chrome</span>
                <span>备案号：蜀ICP备16018998号-3 版权所有 ©</span>
            </div>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui'
export default {
    data() {
        return {
            link1: '',
            link2: '',
            link3: '',
        }
    },
    methods:{
        jumpOuter(link){
            if(link){
                window.open(link)
            }else{
                Message({ message:'暂未开放', type:'info'})
            }
        }
    }
}
</script>
<style>
.index-content *{
    /* margin: 0;
    padding: 0; */
    box-sizing: border-box;
}

.index-content ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.index-content ::-webkit-scrollbar-track {
    border-radius: 3px;
    background: #f5f5f5;
}

.index-content ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(216, 216, 216, 1);
}

.index-content {
    width: 100%;
    background: #fff;
    font-size: 14px;
    color: #0B2640;
    
}

.g-width {
    width: 1200px;
    margin: 0 auto;
}

.b-bottom {
    border-bottom: 1px #CED3D9 solid;
}

.flex {
    display: flex;
}

.w-100 {
    width: 100%;
    min-width: 1200px;
}

.linkfooter {
    display: flex;
    font-size: 18px;
    height: 70px;
    align-items: center;
    justify-content: space-around;
}

.bgcolorFooter {
    background-color: rgba(10, 48, 90, 1);
    height: 280px;
    color: #fff;
}

.f18b {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 21px;
}

.bgcolorFooter>.g-width {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 90%;
}

.bgcolorFooter>.g-width>div {
    height: 100px;
}

.f-text {
    color: #fff;
    font-size: 12px;
    width: fit-content;
    margin: auto;
}

.bgcolor2 {
    background-color: rgba(242, 245, 247, 1);
}

.breadbox {
    border-bottom: 1px solid rgba(206, 211, 217, 1);
    padding-bottom: 15px;
    margin-top: 40px;
}
</style>
